import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import Onboarding2022App from 'bundles/onboarding-2022/components/Onboarding2022App';
import NotFound from 'bundles/phoenix/components/NotFound';

const OnboardingPage = loadOnRoute(() => import('bundles/onboarding-2022/components/OnboardingPage'));
const LearningPlanChatPage = loadOnRoute(() => import('bundles/onboarding-2022/components/LearningPlanChatPage'));

export default (
  <Route path="/" component={Onboarding2022App}>
    {/* Specific route must be ahead of /:questionId so 'learning-plan' isn't treated as a question id. */}
    <Route path="onboarding/learning-plan" getComponent={LearningPlanChatPage} />
    <Route path="onboarding-2022/:questionId" getComponent={OnboardingPage} />
    <Route path="onboarding-2022" getComponent={OnboardingPage} />
    <Route path="onboarding/:questionId" getComponent={OnboardingPage} />
    <Route path="onboarding" getComponent={OnboardingPage} />
    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </Route>
);
